function ErrorMessage({ message }: { message: string }) {
	return <span className="form-field-error">{message}</span>;
}

export default function ErrorMessages({ messages }: { messages: string[] }) {
	return (
		messages.length > 0 && (
			<div className="form-field-errors">
				{messages.map((message, index) => (
					<ErrorMessage key={index} message={message} />
				))}
			</div>
		)
	);
}
